import { Accordion, Badge } from '@mantine/core';
import { useFormik } from 'formik';
import type { ISettingPreset } from '@newo/api/gateway';
import { FC } from 'react';
import SettingField from '@/modules/Integrations/components/SettingField';

type FormikInstanceType = ReturnType<typeof useFormik>;
type GroupDataType = {
    group: string;
    values: ISettingPreset[];
};

type ConnectorGroupPropsType = {
    groupData: GroupDataType;
    formik: FormikInstanceType;
};

const ConnectorGroup: FC<ConnectorGroupPropsType> = ({ groupData, formik }) => {
    const { group, values } = groupData;

    return (
        <Accordion
            multiple
            className="radius='md' bg-[#FAFAFA] rounded-[8px]"
            key={group}
        >
            <Accordion.Item
                className="rounded-xl border border-solid border-gray-3"
                value={group}
            >
                <Accordion.Control>
                    <div className="text-sm flex gap-2 items-center">
                        <span className="first-letter:uppercase!">{group}</span>
                        <Badge
                            className="h-[18px] text-blue-500 bg-blue-100 rounded-[12px] leading-[12px]"
                            size="xs"
                        >
                            {values.length}
                        </Badge>
                    </div>
                </Accordion.Control>
                <Accordion.Panel>
                    <div className="w-full flex flex-col relative gap-2">
                        {values.map((control) => (
                            <SettingField
                                control={control}
                                error={
                                    formik.errors[control.idn] as
                                        string | undefined
                                }
                                key={control.idn}
                                value={formik.values[control.idn] as string}
                                onChange={(value) => {
                                    formik.setFieldValue(control.idn, value);
                                }}
                            />
                        ))}
                    </div>
                </Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    );
};

export default ConnectorGroup;
